import { render, staticRenderFns } from "./ArticleReportIssue.vue?vue&type=template&id=95d53b9a&scoped=true"
import script from "./ArticleReportIssue.vue?vue&type=script&lang=js"
export * from "./ArticleReportIssue.vue?vue&type=script&lang=js"
import style0 from "./ArticleReportIssue.vue?vue&type=style&index=0&id=95d53b9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d53b9a",
  null
  
)

export default component.exports